module.exports = __webpack_public_path__ + "static/media/chatboss-2.fa16f041.svg";